import { render } from "./BaseTypeNewForm.vue?vue&type=template&id=47676933&scoped=true"
import script from "./BaseTypeNewForm.vue?vue&type=script&lang=js"
export * from "./BaseTypeNewForm.vue?vue&type=script&lang=js"

import "./BaseTypeNewForm.vue?vue&type=style&index=0&id=47676933&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47676933"]])

export default __exports__